import { semanticColorLight, semanticColorDark, componentColorLight, componentColorDark, systemColorDark, systemColorLight } from './tokens/index.js';
export const getTokens = (name) => ({
    sem: {
        ...(name === 'dark' ? semanticColorDark : semanticColorLight)
    },
    cmp: {
        ...(name === 'dark' ? componentColorDark : componentColorLight)
    },
    sys: {
        ...(name === 'dark' ? systemColorDark : systemColorLight)
    }
});
//# sourceMappingURL=index.js.map